import { Component } from '@angular/core';

@Component({
  selector: 'empathy-info-page-description',
  templateUrl: 'info-page-description.component.html',
  styleUrls: ['./info-page-description.component.scss']
})
export class InfoPageDescriptionComponent {}
